import { useEffect } from 'react';

/**
 * @nmae useBackgroundColor
 * @external https://www.terluinwebdesign.nl/en/css/incoming-20-new-css-viewport-units-svh-lvh-dvh-svw-lvw-dvw
 * @description Due to how unreliably we're able to set a fixed "canvas" to
 * work with, we have to go outside of the context of our NextJS app and
 * manipulate the HTML element directly, from the React lifecycle.
 */
export const useBackgroundColor = (color: string) => {
  useEffect(() => {
    const html = document.getElementsByTagName('html')[0];
    html.style.backgroundColor = color;

    return () => {
      html.style.backgroundColor = '';
    };
  }, []);
};
